module.exports = __webpack_public_path__ + "media/images/hono16-e687633745ce1eadc2e70a1a7ebbd507.png";